import 'waypoints/lib/jquery.waypoints.min.js';
import 'waypoints/lib/shortcuts/inview.min.js';

export const initScrollAndView = function (config) {
  let elements = [];
  $("main section").each((function (t) {
    let element = $("section").eq(t);
    elements[element] = new Waypoint.Inview({
      element: $(this),
      offset: 'bottom-in-view',
      enter: function () {
        entering(element)
      },
      exited: function (event) {
        exiting(element, event)
      },
    });

  }));

  function entering($el) {
    $el.addClass("isVisible").removeClass("isBelow isAbove notInViewport");
    $el.trigger('classChange');
  }

  function exiting($el, event) {
    var i = "up" == event ? "isBelow" : "isAbove";
    $el.addClass(i + " notInViewport").removeClass("isVisible");
  }
}
